import { RouteObject } from 'react-router';

import { ImportedListingPageContainerLoadable } from 'modules/listing/pages/imported/view/ImportedListingPageContainerLoadable';
import { loadableLoader } from 'routing/utils/loadableLoader';

import { importedListingRoute } from './imported-listing.routes';

export const importedListingRouteObjects = [
  {
    path: importedListingRoute.fullPath,
    loader: loadableLoader(ImportedListingPageContainerLoadable),
    Component: ImportedListingPageContainerLoadable,
  },
] satisfies RouteObject[];
